import type { Creator } from '@fluenceur/types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import api from '@/libs/axiosInstance';

const fetchCreator = async (creatorId: string): Promise<Creator> => {
  const response = await api.get(`/dashboard/creators/${creatorId}`);
  return response.data;
};

export const useFetchCreator = (
  creatorId: string,
  options: { enabled?: boolean } = {}
): UseQueryResult<Creator, Error> => {
  const { enabled = true } = options;
  return useQuery<Creator, Error>({
    queryKey: ['creator', creatorId],
    queryFn: () => fetchCreator(creatorId),
    enabled: enabled && !!creatorId,
    // Creator details are effectively static within a session; a stale window
    // collapses the focus/remount refetches React Query would otherwise fire
    // (one open of the invite modal or creator drawer was hitting the endpoint
    // several times) down to a single request.
    staleTime: 5 * 60 * 1000,
  });
};
